import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    viewPerspective: 'perspective-default',
    modalState: false,
    mapModalState: false,
  },
  mutations: {
    getViewPerspectiveValue(state, payload) {
      state.viewPerspective = payload
    },
    getModalState(state, payload) {
      state.modalState = payload
    },
    getMapModalState(state, payload) {
      state.mapModalState = payload
    },
  },
  actions: {
    updateViewPerspectiveValue (context, payload) {
      context.commit('getViewPerspectiveValue', payload)
    },
    updateModalState (context, payload) {
      context.commit('getModalState', payload)
    },
    updateMapModalState (context, payload) {
      context.commit('getMapModalState', payload)
    },
  },
  getters: {
    getterViewPerspectiveValue(state) {
      return state.viewPerspective
    },
    getterModalState(state) {
      return state.modalState
    },
    getterMapModalState(state) {
      return state.mapModalState
    },
  }
});
